import { getFinancialPlanId, saveFinancialPlanId } from '../../js/app/react/financialPlans';

export const SET_CAPSULE_FP_ID = 'FP.SET_CAPSULE_FP_ID';
export const SET_CAPSULE_FP_NAME = 'FP.SET_CAPSULE_FP_NAME';

export const setCapsuleFpIdWithoutCaching = (fpId, capsuleId, clientId) => ({
  type: SET_CAPSULE_FP_ID,
  fpId,
  capsuleId,
  clientId,
  planName: ADV.consumer.getPlanName(clientId, fpId),
});

export const setCapsuleFpId = (capsuleId, fpId, clientId) => dispatch => {
  saveFinancialPlanId(`Capsule-${capsuleId}`, fpId, clientId);
  dispatch(setCapsuleFpIdWithoutCaching(fpId, capsuleId, clientId));
};

export const fetchDefaultFpId = (capsuleId, clientId) => (dispatch, getState) => {
  getFinancialPlanId(
    clientId,
    `Capsule-${capsuleId}`,
    dispatch,
    getState(),
    fpId => {
      dispatch(setCapsuleFpId(capsuleId, fpId, clientId));
    },
    error => {
      console.error(error);
    },
  );
};
